<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b"><a id="page_6"></a><img alt="image" src="images/f0006-01.jpg"/></h3>
<p class="noindent"> </p>
<p class="imagetoc"><span class="nounder" href="#/xhtml/Introduction" title="Link target outside of Sample"><span class="small">INTRODUCTION</span></span><br/><br/><span class="nounder" href="#/xhtml/Introduction#sugar" title="Link target outside of Sample">SUGAR—THE PREQUEL!<br/><span class="small">A BRIEF HISTORY OF THE WORLD (AS IT PERTAINS TO SUGAR)</span></span><br/><br/><span class="nounder" href="#/xhtml/Introduction#what" title="Link target outside of Sample"><span class="small">WHAT YOU’LL NEED TO GET STARTED</span></span></p>
<p class="noindent"> </p>
<p class="imagetoc"><span class="nounder" href="#/xhtml/Section1#ch1" title="Link target outside of Sample">SIMPLE DISSOLVE TO THREAD STAGE</span><br/>230°F–235°F<br/>(110°C–113°C)<br/><em>Sugar Concentration:</em><br/>80%</p>
<p class="noindent"> </p>
<p class="imagetoc"><span class="nounder" href="#/xhtml/Section2#ch2" title="Link target outside of Sample">SOFT-BALL STAGE</span><br/>235°F–240°F<br/>(113°C–116°C)<br/><em>Sugar Concentration:</em><br/>85%</p>
<p class="noindent"> </p>
<p class="imagetoc"><span class="nounder" href="#/xhtml/Section3#ch3" title="Link target outside of Sample">FIRM-BALL STAGE</span><br/>245°F–250°F<br/>(118°C–121°C)<br/><em>Sugar Concentration:</em><br/>87%</p>
<p class="noindent"> </p>
<p class="imagetoc"><span class="nounder" href="#/xhtml/Section6#ch6" title="Link target outside of Sample">HARD-CRACK STAGE (AND BEYOND)</span><br/>300°F–310°F<br/>(149°C–154°C)<br/><em>Sugar Concentration:</em><br/>99%</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6b828ed6